import React from 'react'
import { PrismicLink, PrismicRichText } from '@prismicio/react'

const Text = ({ slice }) => {
  var position = 'justify-center'
  if (slice.slice_label === 'button_left') {
    position = 'justify-start'
  } else if (slice.slice_label === 'button_right') {
    position = 'justify-end'
  }
  return (
    <section className={`component-text ${slice.primary.columns === true && 'border-b'} mx-auto w-full max-w-screen-xl px-6 py-8 md:py-10`}>
      <div className={`${slice.primary.columns === true ? 'columns ' : 'prose-lg '}prose ${slice.primary.button_text !== null && 'pb-6'} max-w-full`}>
        <PrismicRichText field={slice.primary.text.richText} />
      </div>
      {slice.primary.button_text !== null && (
        <div className={`flex items-center ${position}`}>
          <PrismicLink className='button button-primary text-lg' field={slice.primary.button_link}>
            {slice.primary.button_text}
          </PrismicLink>
        </div>
      )}
    </section>
  )
}

export default Text
